import React from "react";

const SVG = ({
  style = {},
  fill = "#1D1D1B",
  width = "100%",
  className = "",
  viewBox = "0 0 100 100"
}) => (
  <svg
    width={width}
    style={style}
    height={width}
    viewBox={viewBox}
    xmlns="http://www.w3.org/2000/svg"
    className={`svg-icon ${className || ""}`}
    xmlnsXlink="http://www.w3.org/1999/xlink"
  >
    <path
      fill={fill}
      d="M94.4,29.3c-0.7-4.3-2.8-7.9-5.8-11c-3.8-4-8.5-6.3-13.9-7.5c-4.6-1-9-0.5-13.3,1.3
		c-4.4,1.8-8,4.5-11.2,8.2c-0.2-0.3-0.3-0.5-0.5-0.6c-0.2-0.2-0.3-0.4-0.5-0.5c-6.6-6.3-14-10.2-23.5-8.3
		c-4.6,0.9-8.6,2.8-12.2,5.8C9,20.5,6.2,25.5,5.3,31.2c-0.7,4.1-0.3,8.3,1,12.3c1.5,4.5,3.5,8.8,6.8,12.2
		c5.3,5.3,10.7,10.5,16.1,15.7c6,5.7,12.1,11.3,18.2,17c1.8,1.7,2.9,1.7,4.7,0c0.6-0.5,1.2-1,1.8-1.6c3-2.7,5.8-5.4,8.9-8
		c1.4-1.2,2.4-2.4,4.9-1.8c4.2,1,8.4,0.1,11.7-3c4.1-3.7,6.7-8.1,5.6-13.9c-0.2-1.3,0-2.3,0.8-3.4c1.9-2.4,3.6-5,5.2-7.5
		c2.1-3.3,3.4-6.9,3.7-10.7C95.1,35.5,94.8,32.4,94.4,29.3z M47.3,79.2c0,0.5,0,1.1,0,2.1c-4.3-4-8.2-7.7-12.2-11.3
		c-5.1-4.8-10.2-9.5-15.3-14.3c-3.8-3.6-6.7-7.9-8.4-12.8c-1.4-4.1-1.9-8.3-0.7-12.5C13,23,17.6,17.9,25,16.1
		c7.3-1.7,13.8,0.3,19.2,5.6c2.3,2.2,3.3,4.5,3.2,7.8C47.3,46,47.4,62.6,47.3,79.2z M74.7,72.3c-0.5,0.2-1,0.5-1.6,0.6
		c-0.8,0.1-1.5,0.1-2,0.2c-5.2,0-9.1-3.5-10.3-8.2C59.9,61,61.2,58,63.2,55c2.2-3.1,4.6-6.1,6.8-9.2c0.8-1,1.3-0.7,1.8,0.1
		c2.6,3.8,5.1,7.6,7.7,11.4C83.6,63,79.8,70,74.7,72.3z"
    />
  </svg>
);

export default SVG;